import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  ReadSfBankAccountsRequestDto,
  ReadSfBankAccountsResponseDto,
  CreateSfBankAccountRequestDto,
  CreateSfBankAccountResponseDto,
  UpdateSfBankAccountRequestDto,
  UpdateSfBankAccountResponseDto,
  ReadUserSfBankAccountRequestDto,
  ReadUserSfBankAccountResponseDto,
  AssignSfBankAccountToUserRequestDto,
  AssignSfBankAccountToUserResponseDto,
  UnassignSfBankAccountFromUserRequestDto,
  UnassignSfBankAccountFromUserResponseDto,
} from '@sparling/financial-common'

export const {
  request: getSfBankAccountsRequest,
  success: getSfBankAccountsSuccess,
  failure: getSfBankAccountsFailure,
} = createAsyncAction('GET_SF_BANK_ACCOUNTS_REQUEST', 'GET_SF_BANK_ACCOUNTS_SUCCESS', 'GET_SF_BANK_ACCOUNTS_FAILURE')<
  ReadSfBankAccountsRequestDto,
  ReadSfBankAccountsResponseDto,
  Error
>()

export const {
  request: createSfBankAccountRequest,
  success: createSfBankAccountSuccess,
  failure: createSfBankAccountFailure,
} = createAsyncAction(
  'CREATE_SF_BANK_ACCOUNT_REQUEST',
  'CREATE_SF_BANK_ACCOUNT_SUCCESS',
  'CREATE_SF_BANK_ACCOUNT_FAILURE',
)<CreateSfBankAccountRequestDto, CreateSfBankAccountResponseDto, Error>()

export const {
  request: updateSfBankAccountRequest,
  success: updateSfBankAccountSuccess,
  failure: updateSfBankAccountFailure,
} = createAsyncAction(
  'UPDATE_SF_BANK_ACCOUNT_REQUEST',
  'UPDATE_SF_BANK_ACCOUNT_SUCCESS',
  'UPDATE_SF_BANK_ACCOUNT_FAILURE',
)<UpdateSfBankAccountRequestDto, UpdateSfBankAccountResponseDto, Error>()

export const {
  request: getAssignedAccountsByUserRequest,
  success: getAssignedAccountsByUserSuccess,
  failure: getAssignedAccountsByUserFailure,
} = createAsyncAction(
  'GET_ASSIGNED_ACCOUNTS_BY_USER_REQUEST',
  'GET_ASSIGNED_ACCOUNTS_BY_USER_SUCCESS',
  'GET_ASSIGNED_ACCOUNTS_BY_USER_FAILURE',
)<ReadUserSfBankAccountRequestDto, ReadUserSfBankAccountResponseDto, Error>()

export const {
  request: getAssignedAccountIdsByUserRequest,
  success: getAssignedAccountIdsByUserSuccess,
  failure: getAssignedAccountIdsByUserFailure,
} = createAsyncAction(
  'GET_ASSIGNED_ACCOUNT_IDS_BY_USER_REQUEST',
  'GET_ASSIGNED_ACCOUNT_IDS_BY_USER_SUCCESS',
  'GET_ASSIGNED_ACCOUNT_IDS_BY_USER_FAILURE',
)<{ idSf: string }, number[], Error>()

export const {
  request: assignSfBankAccountToUserRequest,
  success: assignSfBankAccountToUserSuccess,
  failure: assignSfBankAccountToUserFailure,
} = createAsyncAction(
  'ASSIGN_SF_BANK_ACCOUNT_TO_USER_REQUEST',
  'ASSIGN_SF_BANK_ACCOUNT_TO_USER_SUCCESS',
  'ASSIGN_SF_BANK_ACCOUNT_TO_USER_FAILURE',
)<AssignSfBankAccountToUserRequestDto, AssignSfBankAccountToUserResponseDto, Error>()

export const {
  request: unassignSfBankAccountFromUserRequest,
  success: unassignSfBankAccountFromUserSuccess,
  failure: unassignSfBankAccountFromUserFailure,
} = createAsyncAction(
  'UNASSIGN_SF_BANK_ACCOUNT_FROM_USER_REQUEST',
  'UNASSIGN_SF_BANK_ACCOUNT_FROM_USER_SUCCESS',
  'UNASSIGN_SF_BANK_ACCOUNT_FROM_USER_FAILURE',
)<UnassignSfBankAccountFromUserRequestDto, UnassignSfBankAccountFromUserResponseDto, Error>()

export const resetSfBankAccountsFilters = createAction('RESET_SF_BANK_ACCOUNTS_FILTERS')<undefined>()
